// Figma: https://www.figma.com/design/nykbXADUTliE6d7xv6FjcQ/NEW-TSAB-Shared-Customer-Library?node-id=83-1923&m=dev
// Component: TripLocations — Display view
// Departure → optional stops → destination with connecting line and icons

import { formatAddressParts } from '~/utils/format'

function PickupDot() {
  return <div className="w-2 h-2 rounded-[4px] bg-on-surface shrink-0" />
}

function StopDot() {
  return <div className="size-2 rounded-[1px] bg-on-surface shrink-0" />
}

function PinIcon() {
  return (
    <svg width="12" height="12" viewBox="0 0 12 12" fill="none" aria-hidden="true" className="shrink-0">
      <path fillRule="evenodd" clipRule="evenodd" d="M6 0C3.79 0 2 1.79 2 4c0 2.5 3.5 7.5 4 8 .5-.5 4-5.5 4-8 0-2.21-1.79-4-4-4zm0 5.5a1.5 1.5 0 100-3 1.5 1.5 0 000 3z" fill="#17181A" />
    </svg>
  )
}

function SolidLine() {
  return <div className="w-0.5 bg-on-surface flex-1" />
}

function EmptyLine() {
  return <div className="flex-1" />
}

function LocationRow({ location, icon, lineAbove, lineBelow }) {
  const { title, subtitle } = formatAddressParts(location)
  return (
    <div className="flex gap-3">
      {/* Icon column — 44px wide, line runs full height */}
      <div className="shrink-0 w-11 flex flex-col items-center">
        {lineAbove === 'solid' ? <SolidLine /> : <EmptyLine />}
        {icon}
        {lineBelow === 'solid' ? <SolidLine /> : <EmptyLine />}
      </div>

      {/* Text */}
      <div className="flex-1 flex flex-col py-3 min-w-0">
        <span className="text-[17px] font-medium tracking-[-0.34px] leading-[22px] text-on-surface">{title}</span>
        {subtitle && (
          <span className="text-[15px] leading-5 text-on-surface-variant">{subtitle}</span>
        )}
      </div>
    </div>
  )
}

export default function TripLocations({ departure, destination, stops = [] }) {
  const hasDestination = Boolean(destination?.address)
  const allRows = [
    departure,
    ...stops,
    ...(hasDestination ? [destination] : []),
  ].filter(Boolean)

  return (
    <div>
      {allRows.map((location, i) => {
        const isFirst = i === 0
        const isLast = i === allRows.length - 1
        const isDestination = isLast && hasDestination

        const icon = isDestination ? <PinIcon /> : isFirst ? <PickupDot /> : <StopDot />
        const lineAbove = isFirst ? 'empty' : 'solid'
        const lineBelow = isLast ? 'empty' : 'solid'

        return (
          <LocationRow
            key={i}
            location={location}
            icon={icon}
            lineAbove={lineAbove}
            lineBelow={lineBelow}
          />
        )
      })}
    </div>
  )
}
